import api from '../api/api-list'
import { Toast } from 'cube-ui'


const state =  {
  allCommentData: [], // 点评的所有数据
  viewCommentId: 1, // 当前查看的经历id
  viewCommentType: '', // 当前查看的是profile或者是extras
  currentCommentInfo: {} // 当前点击的点评的info
}

const getters = {
  viewCommentData: state => {
    let { type, info_id } = state.currentCommentInfo
    if (type === 'profile' || type === 'extras') {
      return state.allCommentData.find(item => item.type === type) || { comments: [], comment_count: 0 }
    } else {
      return state.allCommentData.find(item => item.info_id === info_id) || { comments: [], comment_count: 0 }
    }
  }
}

// 深拷贝全部的点评数据，返回当前点评的info在全部点评数据中的index
const deepCloneCommentData = (allCommentData, currentCommentInfo) => {
  let commentData = JSON.parse(JSON.stringify(allCommentData))
  let { info_id, type } = currentCommentInfo
  let commentIndex = -1
  if (type === 'profile' || type === 'extras') {
    commentIndex = commentData.findIndex(item => item.type === type)
  } else if (info_id) {
    commentIndex = commentData.findIndex(item => item.info_id === info_id)
  }
  return {
    commentIndex,
    commentData,
    info_id,
    type
  }
}

const actions = {
  // 获取简历点评数据
  getCommentData: async function({ commit, state, rootState }, { payload }) {
    try {
      let { cv:{ basic_info:{ token } } } = rootState.cv
      let res = await api.cvComment.getWholeCommentData(token, payload)
      if (res.code === 1000) {
        if (payload.type === 'profile' || payload.type === 'extras' || payload.info_id) {
          let { commentIndex, commentData } = deepCloneCommentData(state.allCommentData, state.currentCommentInfo)
          let data = res.data.comment_data[0] ? res.data.comment_data[0].comments : []
          // 将当前展示的点评列表数据提取出来
          let currentCommentList = commentData[commentIndex].comments
          for (let i = 0; i < data.length; i++) {
            let index = currentCommentList.findIndex(item => item.id === data[i].id)
            if (index > -1) {
              currentCommentList.splice(index, 1)
            }
          }
          commentData[commentIndex].comments = [ ...currentCommentList, ...data ]
          commit('setAllCommentData', commentData)
        } else {
          commit('setAllCommentData', res.data.comment_data)
        }
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 添加简历点评
  addCommentForCv: async function({ commit, state, rootState }, { payload }) {
    try {
      let { cv:{ basic_info:{ token } } } = rootState.cv
      let res = await api.cvComment.addCvComment(token, { ...state.currentCommentInfo, ...payload })
      if (res.code === 1000) {
        let { commentIndex, commentData, info_id, type } = deepCloneCommentData(state.allCommentData, state.currentCommentInfo)
        if (commentIndex > -1) {
          commentData[commentIndex].comments = [ ...commentData[commentIndex].comments, res.data ]
          commentData[commentIndex].comment_count += 1
        } else {
          commentData = [ ...commentData, {
            comments: [ res.data ],
            comment_count: 1,
            info_id,
            type
          } ]
          res.firstCommentData = true
        }
        commit('setAllCommentData', commentData)
      }
      return res
    } catch (e) {
      console.log(e)
    }
  },
  // 删除简历点评
  deleteCommentForCv: async function({ commit, state, rootState }, { commentId }) {
    try {
      let { cv:{ basic_info:{ token } } } = rootState.cv
      let res = await api.cvComment.deleteCvComment(token, commentId)
      if (res.code === 1000) {
        let { commentIndex, commentData } = deepCloneCommentData(state.allCommentData, state.currentCommentInfo)
        if (commentIndex > -1) {
          commentData[commentIndex].comments = commentData[commentIndex].comments.filter(item => item.id !== commentId)
          commentData[commentIndex].comment_count -= 1
          if (!commentData[commentIndex].comment_count) {
            res.commentEmpty = true
          }
          commit('setAllCommentData', commentData)
        }
      }
      return res
    } catch (e) {
      console.log(e)
    }
  }
}

const mutations = {
  // set 简历点评的所有数据
  setAllCommentData (state, data) {
    state.allCommentData = data
  },
  // set 当前查看的点评的模块的id
  setViewCommentId(state, id) {
    state.viewCommentId = id
  },
  // set 当前查看的是基本信息 或者 extras
  setViewCommentType(state, type) {
    state.viewCommentType = type
  },
  // set 当前点击的点评的info
  setCurrentCommentInfo(state, data) {
    state.currentCommentInfo = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

